import React, { useContext } from "react";
import { MenuSelection } from "../../../components/menuButtons/MenuSelection";
import { Loader } from "../../../components/loader/Loader";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";
import { SaveImage } from "../../../components/SaveImage";
import { StoreContext } from "../../../store/Store";

export const Controls = () => {
  const [store] = useContext(StoreContext);
  const [lstore] = useContext(LocalStoreContext);
  const refs = useContext(RefContext);
  const { loading } = lstore;
  const { defaultTicker } = store;

  return (
    <div
      style={{
        height: refs.componentSize.current["Controls"].height,
        width: refs.componentSize.current["Controls"].width - 17,
        margin: 0,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      {!loading && (
        <SaveImage
          label="Download Strength"
          prefix="strength"
          selectkeys={["ticker"]}
          svgRef={refs.comboRef}
        />
      )}
      <div style={{ width: 10 }}></div>
      {!loading && (
        <SaveImage
          label="Download Study"
          prefix="study"
          selectkeys={["ticker"]}
          svgRef={refs.studyRef}
        />
      )}
      <div style={{ width: 30 }}>{loading && <Loader width={20} />}</div>
      <MenuSelection
        menukey="ticker"
        defaultSelection={defaultTicker}
        label="Ticker"
        inputType="radio"
        data={["nothing needed"]}
      />
    </div>
  );
};
